import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, SecurityContext, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, NavigationStart} from '@angular/router';
import {FilterService} from '../../../services/sp-filter/filter.service';
import {BaseStatFilter, ItemBlacklist} from '../../../classes/filter/base-stat-filter';
import {HeaderOption, NavigationService} from '../../../services/sp-navigation/navigation.service';
import { ProjectManagerService, ProjectSortType, AnyFolder } from '../../../services/sp-project/project-manager.service';
import {Project} from '../../../models/project';
import {Audience} from '../../../models/audience';
import {environment} from '../../../../environments/environment';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import {LoaderService} from '../../../services/sp-loading/loader.service';
import {ApiDataService} from '../../../services/sp-api/sp-api-data/api-data.service';
import fileSaver from 'file-saver';
import {ChartService} from '../../../services/sp-chart/chart.service';
import {DataType} from '../../../classes/data/stat-handler';
import {Subject, Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {AlertService} from '../../../services/sp-alert/alert.service';
import {LoggerService} from '../../../services/sp-logger/logger.service';
import {FacebookLinkService} from '../../../services/sp-facebook/facebook-link.service';
import {RoleUtils} from '../../../utils/role/role-utils';
import {Notification} from '../../../models/notification';
import {CookieService} from "ngx-cookie-service";
import {Link, ReportingManager} from '../../../services/sp-reporting/reporting-manager.service';
import {SpDashboardTabCreationModalComponent} from '../../sp-dashboard/sp-dashboard-tab-creation-modal/sp-dashboard-tab-creation-modal.component';
import {ApiDashboardService} from '../../../services/sp-api/sp-api-dashboard/api-dashboard.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {SpCustomThemeService} from '../../../services/sp-custom-logo/sp-custom-theme.service';
import {Targeting} from '../../../classes/targeting/targeting';
import {MatTabLink} from '@angular/material/tabs';
import {ApiUserService} from '../../../services/sp-api/sp-api-user/api-user.service';
import {Dashboard} from '../../../models/dashboard';
import {Folder} from '../../../models/folder';
import {
  SpModalProjectListFolderCreateComponent
} from '../../sp-project/sp-project-list/sp-modal-project-list-folder-create/sp-modal-project-list-folder-create.component';
import {ArrayUtils} from '../../../utils/array-utils';
import { OverlayContainer } from '@angular/cdk/overlay';
import {SpModalInfoComponent} from '../../sp-modal/sp-modal-info/sp-modal-info.component';
import {SpModalConfirmComponent} from '../../sp-modal/sp-modal-confirm/sp-modal-confirm.component';
import {FilterDrawerComponent} from '../../../filter-drawer/filter-drawer.component';
import {TrackerService} from '../../../services/sp-tracker/tracker.service';
import { DisplayMode } from '../../ai-component/insights-summary/ai-report-summary.component';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { AuthService } from 'src/app/services/sp-authentication/auth.service';
import { GridConfig } from '../../../classes/reporting/grid-config';
import { InterestCategoriesService } from '../../../services/sp-interest-categories/interest-categories.service';
import { metaReportTabUrl } from '../../../services/sp-tab-pointer/di-report-url';
import { DiReportNavigatorService } from '../../../services/sp-navigation/di-report-navigator.service';

@Component({
  selector: 'app-sp-layout-dashboard-desk',
  templateUrl: './sp-layout-dashboard-desk.component.html',
  styleUrls: ['./sp-layout-dashboard-desk.component.scss']
})

export class SpLayoutDashboardDeskComponent implements OnInit, OnDestroy, AfterViewInit {
  showFreemiumVideo = true;
  DisplayMode = DisplayMode;
  forceHideFacebookBanner = true;
  isFbLogged = false;
  hasUserAllFbScopes = false;
  areUserAdAccountsValid = false;

  loading = false;
  selectedImage: any = null;
  showFree = false;
  showNotificationBanner = false;

  // Criterion related
  rangeValuesPenetrationCriteria: number[] = [5, 100];
  rangeValuesSelectivityCriteria: number[] = [0, 200];
  criteriaBlacklist: ItemBlacklist[] = [];

  // Tags related
  rangeValuesPenetrationTags: number[] = [3, 100];
  rangeValuesSelectivityTags: number[] = [0, 200];
  tagBlacklist: ItemBlacklist[] = [];

  // Target
  targetSize: number [] = [0, 60000000];
  targetSizeMax: number = 60000000;
  targetSizeMin: number = 0;

  searchText: string;
  searchProject: string = "";

  env = environment;

  // Subscriptions
  private subscriptions: Subscription[] = [];

  // Links
  links: Link[] = [];
  // Filter thresholds
  criteriaScorableMaxThreshold: number = 200;
  tagScorableMaxThreshold: number = 200;

  // Permissions
  companyManager: boolean = false;
  userAdmin: boolean = false;
  tagAdmin: boolean = false;
  dataExport: boolean = false;
  dashboardAccess: boolean = false;
  metaExportAccess: boolean = false;

  // Bot
  downloading = false;
  freemium = false;

  // Notification
  lastNofication: Notification;
  notificationClosed: boolean = false;

  // Blocked user
  userBlockedMessage?: string;

  hideFirstStep = false;
  url: string | ArrayBuffer;

  projectSharedName: string = null
  dashboardPath = "";

  private readonly defaultLogo: string = "assets/images/logos/audiense/logo-soprism-by-audiense.svg";
  dashboardLogo: string = this.defaultLogo;
  dashboardLogoBase64 = false;

  //User
  isUserSuperAdmin = false;

  showInterestCategoriesTab = false;

  filterText: string = "";
  filterTextDashboardList: string = "";
  filterTextProjectList: string = "";

  //Targeting
  exportName?: string;
  exportTargeting?: Targeting;
  exportType;

  dashboardList: Dashboard[] = [];
  templateList: Dashboard[] = [];

  isCustomDashboardEditable: boolean;
  sortedProjects;
  selectedProject;

  showSidebarContent: string;
  isPanelProjectInFolderOpen = false;

  // Project list filter
  private projectFilterChangeSubject: Subject<string> = new Subject();
  protected isFilterProcessRunning: boolean = false;

  // View open states
  isPanelProjectOpen = false;
  isPanelFolderOpen = false;
  isPanelDashboardOpen = false;
  isPanelTemplateOpen = false;
  displaySidebar = false;

  // we create an object that contains coordinates
  menuTopLeftPosition =  {x: 0, y: 0}

  /// For project list
  projectReadyCount = 0;
  typeFiltering: string[] = ['project', 'project_shared', 'folder'];
  sortType: ProjectSortType = ProjectSortType.CREATION_DATE;
  canSeeCustomFolder = false;
  isProjectSearchClicked = false;
  tabClicked: Link;
  showEditMode = false;

  // DOM references
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger2: MatMenuTrigger;
  @ViewChild('newName',{static: true}) newTabName: MatTabLink;
  @ViewChild("filterMenu",{static: true}) filterMenu: MatMenu;
  @ViewChild("matMenuTrigger", {static: true}) matMenuTrigger: MatMenuTrigger;
  @ViewChild('chatBox', {static: true}) chatBox: ElementRef;
  @ViewChild('userMsg',{static: true}) inputName;

  constructor(
    public sessionProvider: SessionProviderService,
    public router: Router,
    private route: ActivatedRoute,
    public filterService: FilterService,
    public navigation: NavigationService,
    public projectManager: ProjectManagerService,
    public loader: LoaderService,
    private apiData: ApiDataService,
    private dialog: MatDialog,
    private alert: AlertService,
    private fb: FacebookLinkService,
    private logger: LoggerService,
    private tracker: TrackerService,
    private cookie: CookieService,
    private apiDashboard: ApiDashboardService,
    public reportingMan: ReportingManager,
    private customTheme: SpCustomThemeService,
    private apiUser: ApiUserService,
    private overlayContainer: OverlayContainer,
    protected auth: AuthService,
    private interestCategories: InterestCategoriesService,
    private diReportNavigator: DiReportNavigatorService
  ) {
    router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        const content = document.getElementById('sp-content');
        if (content) { content.style.height = String(document.documentElement.scrollHeight); }

        const sidebar = document.getElementById('sp-sidebar');
        if (sidebar) { sidebar.style.height = String(document.documentElement.clientHeight); }
      }
    });
  }

  async ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      if (params.has('targeting') && params.has('name')) {
        this.exportName = params.get('name');
        this.exportTargeting = Targeting.fromJson(params.get('targeting'), 'export');
        this.exportType = params.get('type');

      }
    });

    this.freemium = this.sessionProvider.activeSession?.user?.role.level <= RoleUtils.freemiumLevel;
    this.subscriptions.push(this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd && this.freemium) {
        this.showFree = true;
      }
    }));
    this.showFree = this.freemium;
    this.sessionProvider.activeSession?.hasPermission('user.admin').then(authorized => {
      this.userAdmin = authorized;
    });

    this.sessionProvider.activeSession?.hasPermission('tag.admin').then(authorized => {
      this.tagAdmin = authorized;
    });
    this.sessionProvider.activeSession?.hasPermission('company.self.manage').then(authorized => {
      this.companyManager = authorized;
    });
    this.sessionProvider.activeSession?.hasPermission('data.export').then(authorized => {
      this.dataExport = authorized;
    });
    this.sessionProvider.activeSession?.hasPermission('dashboard.access').then(authorized => {
      this.dashboardAccess = authorized;
    });
    this.sessionProvider.activeSession?.hasPermission('targeting.export').then(authorized => {
      this.metaExportAccess = authorized;
    });

    if (this.sessionProvider.activeSession?.user.role.level >= RoleUtils.superAdminLevel) this.isUserSuperAdmin = true;

    this.filterService.onThresholdChange.subscribe(threshold => {
      switch (threshold.flag) {
        case "criterion":
          this.criteriaScorableMaxThreshold = threshold.value;
          this.rangeValuesSelectivityCriteria = [this.rangeValuesSelectivityCriteria[0], threshold.value];
          this.filter.criteriaSelectivityMax = threshold.value;
          break;
        case "tags":
          this.tagScorableMaxThreshold = threshold.value;
          this.rangeValuesSelectivityTags = [this.rangeValuesPenetrationTags[0], threshold.value];
          this.filter.tagScorableMax = threshold.value;
          break;
        case "segment-min":
          this.targetSizeMin = threshold.value;
          this.targetSize[0] = threshold.value;
          break;
        case "segment-max":
          this.targetSizeMax = threshold.value;
          this.targetSize[1] = threshold.value;
          break;
        default:
          this.logger.logWarning("Threshold for flag " + threshold.flag + " is not supported");
      }
    });

    this.subscriptions.push(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.matMenuTrigger?.closeMenu();
      }
    }));

    if (this.sessionProvider.activeSession) {
      this.fb.isLogged().then(async isLogged => {
        // Rechecking of session is fine (could change if the token is expired)
        if (this.sessionProvider.activeSession && this.sessionProvider.activeSession.user) {
          const scopesOk = await this.fb.checkAllScopesAreValid();
          this.isFbLogged = isLogged;
          this.hasUserAllFbScopes = scopesOk;
          this.areUserAdAccountsValid = !this.sessionProvider.activeSession.user.has_invalid_ad_accounts;
        }
      });
      this.freemium = this.sessionProvider.activeSession.user.role.level <= RoleUtils.freemiumLevel;
    }

    this.subscriptions.push(this.navigation.notificationTrigger.subscribe(n => {
      if (!n) {
        this.showNotificationBanner = false;
      } else {
        this.lastNofication = n;
        const now = new Date();
        const startAt = new Date(n.start_on);
        const endAt = new Date(n.end_on);
        if (now >= startAt && now <= endAt && n.active && !this.notificationClosed) {
          this.showNotificationBanner = true;
        } else if (this.showNotificationBanner) {
          this.showNotificationBanner = false;
        }
      }
    }));

    this.subscriptions.push(this.navigation.blockedUserMessageTrigger.subscribe(msg => {
      this.userBlockedMessage = msg;
    }));

    if (this.projectManager.selectedProject) {
      this.dashboardPath = "link/"+ this.projectManager.selectedProject.id;
    }

    this.subscriptions.push(this.customTheme.onLogoChange(img => {
      if (img) {
        this.dashboardLogo = img.image;
        this.dashboardLogoBase64 = img.b64;
      } else {
        this.dashboardLogo = this.defaultLogo;
      }
    }));

    this.subscriptions.push(this.projectManager.projectTypeFilterLoading.subscribe(loading => {
      this.isFilterProcessRunning = loading;
    }));

    if (this.sessionProvider.activeSession) {
      this.projectManager.loadFolders();
      this.loadDashboards()
      this.loadTemplates();
    }

    // Interest Categories tab: shown when the report's latest crawl is recent enough to contain
    // 'new_tags' criteria (see refreshInterestCategoriesTab). Synchronous, no fetch.
    this.subscriptions.push(this.projectManager.selectedProjectChangeListener.subscribe(
      project => this.refreshInterestCategoriesTab(project)));
    if (this.projectManager.selectedProject) {
      this.refreshInterestCategoriesTab(this.projectManager.selectedProject);
    }

    this.subscriptions.push(this.reportingMan.linkCreatedSub(link => {
      this.links.push(link);
    }));
    this.subscriptions.push(this.reportingMan.linkDeletedSub(link => {
      this.links.splice(this.links.indexOf(link), 1);
    }));
    this.subscriptions.push(this.reportingMan.linkOverrideSub(links => {
      this.links = links;
    }));
    this.subscriptions.push(this.navigation.reportingChangeListener.subscribe(reporting => {
      this.ngOnDestroy();
      this.ngOnInit();
    }));
    this.sortedProjects = this.projectManager.allProjects.slice().sort((a, b) => a.name.localeCompare(b.name));
    this.initSidebarContent();

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  toggleDebugMode() {
    environment.config.enableDebugFeatures = !environment.config.enableDebugFeatures;
    if (environment.config.enableDebugFeatures) {
      this.cookie.set("debug", "on", 0, "/", undefined, true, "Strict");
    } else {
      this.cookie.delete("debug", "/");
    }
  }

  closeFreemium(){
    this.showFreemiumVideo = false;
  }
  openFreemium() {
    this.showFreemiumVideo = true;
  }

  toNumberFormat(value: number) {
    return ChartService.separator(value);
  }

  /// Import all dashboards
  loadDashboards() {
    this.apiUser.getDashboards(this.sessionProvider.activeSession.user).then(list => {
      this.dashboardList = list.filter(d => d.preset !== true);
      this.dashboardList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
    });
  }

  goToDashboard(dash:Dashboard) {
    this.router.navigate(['dashboard','reporting', 'list', this.projectManager.selectedProject.id, 'insight', dash.id]).then(()=> {
      this.navigation.notifyReportingChange(dash);
    });
  }

  goToMetaExport() {
    const project = this.projectManager.selectedProject;
    const params: any = {
      'name': project.name,
      'targeting': project.audience_target.target_spec,
      'type': 'project'
    };

    if (project.audience_target.type == 'custom' || project.audience_target.type == 'fanpage') {
      const extra = JSON.parse(project.audience_target.data_extra);
      params.adAccountId = extra.accountId;
      params.adAccountName = extra.accountName;
      params.audienceType = project.audience_target.type;
    }

    this.router.navigate(['targeting'], {queryParams: params}).then();
  }

  audienceSize(audience: Audience) {
    if (audience.latest_crawl) {
      return this.toNumberFormat(audience.latest_crawl.audience_size)
    } else {
      return "N/A"
    }
  }

  private filter: BaseStatFilter = {
    // Criterion
    criteriaPenetrationMin: this.rangeValuesPenetrationCriteria[0],
    criteriaPenetrationMax: this.rangeValuesPenetrationCriteria[1],
    criteriaSelectivityMin: this.rangeValuesSelectivityCriteria[0],
    criteriaSelectivityMax: this.rangeValuesSelectivityCriteria[1],
    criteriaBlacklist: this.criteriaBlacklist,

    // Tags
    tagPenetrationMin: this.rangeValuesPenetrationTags[0],
    tagPenetrationMax: this.rangeValuesPenetrationTags[1],
    tagScorableMin: this.rangeValuesSelectivityTags[0],
    tagScorableMax: this.rangeValuesSelectivityTags[1],
    tagBlacklist: this.tagBlacklist
  };

  onSwitchChange(defaultVal: boolean) {
    // Reset dynamic filter
    this.filterService.baseStatFilterRequest(null);

    const newDataType = defaultVal ? DataType.NORMALIZED : DataType.RAW;
    // Trigger event for data type
    this.navigation.dataTypeChangeListener.next(newDataType);
  }

  async downloadExcel() {
    const project = this.projectManager.selectedProject;
    this.downloading = true;
    if (project) {
      let normalized = this.navigation.currentDataType == DataType.NORMALIZED;
      this.apiData.getDataExcel(project, normalized).then(excelData => {
        this.tracker.track('report_exported', {project_name: project.name, type: 'xlsx', tag_source: 'new_tags'})
        let blob:any = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' });

        fileSaver.saveAs(blob, project.name + '.xlsx');
      }).catch(error => {
        if (error.status == 403) {
          this.alert.notify('Access Denied', 'You are not able to export data', 'error');
        }
      }).finally(() => this.downloading = false);
    }
  }
  async downloadCSV() {
    const project = this.projectManager.selectedProject;
    this.downloading = true;
    if (project) {
      let normalized = true;
      if (this.navigation.currentDataType == DataType.NORMALIZED || this.navigation.currentDataType == DataType.RAW) {
        normalized = this.navigation.currentDataType == DataType.NORMALIZED;
      }
      this.apiData.getDataCSV(project, normalized).then(excelData => {
        this.tracker.track('report_exported', {project_name: project.name, type: 'csv', tag_source: 'new_tags'})
        let blob:any = new Blob([excelData], { type: 'application/zip; charset=utf-8' });

        fileSaver.saveAs(blob, project.name + '.zip');
      }).catch(error => {
        if (error.status == 403) {
          this.alert.notify('Access Denied', 'You are not able to export data', 'error');
        }
      }).finally(() => this.downloading = false);
    }
  }

  scrollTop() {
    window.scroll(0,0);
  }

  hideFacebookLoginBanner() {
    this.forceHideFacebookBanner = true;
  }

  hideBanner() {
    this.showFree = false;
  }
  hideInfoBanner() {
    this.showNotificationBanner = false;
    this.notificationClosed = true;
  }

  openDashboardTabCreation(): void {
    let doNotOpen = false;

    const tabChoice = (type: string): boolean => {
      if (type === "tab") {
        this.reportingMan.createLink("New tab");
        return true;
      } else if (type === "template") {
        const project = this.projectManager.selectedProject;
        this.router.navigate(['dashboard','reporting', 'template', project.id], {queryParams: {'dash_id': this.reportingMan.loadedDashboard.id}}).then();
        return true;
      } else return false;
    }

    const choiceStored = localStorage.getItem("new-tab-modal-choice");
    if (choiceStored) {
      doNotOpen = tabChoice(choiceStored);
    }

    if (!doNotOpen) {
      this.dialog.open(SpDashboardTabCreationModalComponent, {
        autoFocus: false,
        minHeight: '30rem',
        minWidth: '50rem',
        maxHeight: '60rem',
        maxWidth: '50rem',

      }).afterClosed().subscribe(result => {
        if (result) {
          const type = result.type;

          if (result.doNotShowAgain && type) localStorage.setItem("new-tab-modal-choice", type);
          tabChoice(type);
        }
      });
    }
  }

  checkSpaceAndNavigateToWidgetCreation(): void {
    if (!this.reportingMan.hasSpaceForSmallestWidget(GridConfig.MAX_COLS, GridConfig.MAX_ROWS)) {
      this.reportingMan.notifyNoSpaceAvailable();
      return;
    }

    // Navigate to widget creation
    this.router.navigate(
      ['/dashboard/reporting/widget', this.projectManager.selectedProject.id],
      { queryParams: { reporting_id: this.loadedDashboard ? this.loadedDashboard.id : 0 } }
    );
  }

  @HostListener('window:resize', []) onWindowScroll() {
    const element = document.getElementById("sp-header-title-v2");
    if (element) element.style.display = "block";
  }

  onRightClick(event: MouseEvent, item: Link) {
    if (!this.router.url.includes('dashboard/reporting/shared') && this.isCustomDashboardEditable) {
      // preventDefault avoids to show the visualization of the right-click menu of the browser
      event.preventDefault();
      this.tabClicked = item
      // we record the mouse position in our object
      this.menuTopLeftPosition.x = event.clientX;
      this.menuTopLeftPosition.y = event.clientY;
      // we open the menu
      // we pass to the menu the information about our object
      this.matMenuTrigger2.menuData = {item: item}

      // we open the menu
      this.matMenuTrigger2.openMenu();
    }
  }

  deleteTab(){
    this.reportingMan.deleteLink(this.tabClicked);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.links, event.previousIndex, event.currentIndex);
    this.reportingMan.loadLinks(this.links);
    this.reportingMan.linkUpdated();
  }

  setLinkActive(link: Link) {
    this.reportingMan.linkSetActive(link);
    this.showEditMode = false;
  }

  editTab() {
    this.showEditMode = true;
    const input: HTMLInputElement = <HTMLInputElement>document.getElementById("tab-"+this.tabClicked.id);
    const inputEnd = input.value.length;
    input.focus();
    input.setSelectionRange(inputEnd,inputEnd);
  }

  goDataManager() {
    window.location.href='https://control-dev.soprism.com/login';
  }

  changeTabName(newName : MatTabLink){
    const input = <HTMLInputElement>newName.elementRef.nativeElement;
    const newLinkName = input.value;
    const link = this.links.find(x => x.id == this.tabClicked.id);
    link.name = newLinkName;
    this.showEditMode = false;
    this.reportingMan.updateLink(link);
  }

   async loadTemplates() {
     this.templateList = await this.apiDashboard.presets();
   }

  viewTemplate(template: Dashboard, edit: boolean = false) {
    this.router.navigate(['dashboard','reporting' ,'list', this.projectManager.selectedProject.id, 'insight', template.id]).then(() => {
      this.navigation.notifyReportingChange(template);
    });
  }

    navigateTo(header:HeaderOption)
    {
      this.navigation.dontRefreshNext = true;
      this.router.navigate([header.url], header.queryParams ? {queryParams: header.queryParams} : undefined).then();
    }

  changeSidebarContent(sidebarIconHover: string){
    if(sidebarIconHover == "Project list") {
      this.showSidebarContent = "Project list"
    }else if(sidebarIconHover == "Insights") {
      this.showSidebarContent = "Insights"
    }else if(sidebarIconHover == "Persona") {
      this.showSidebarContent = "Persona"
    }else if(sidebarIconHover == "Tag") {
      this.showSidebarContent = "Tag"
    }else if(sidebarIconHover == "Data manager") {
      this.showSidebarContent = "Data manager"
    }else if(sidebarIconHover == "Reporting") {
      this.showSidebarContent = "Reporting"
    }
  }

  initSidebarContent() {
    if (this.router.url.includes("insights/socio-demo")) {
      this.showSidebarContent = "Insights"
    } else if(this.router.url.includes('insights/topics')) {
      this.showSidebarContent = "Insights"
    } else if (this.router.url.includes("insights/overview")) {
      this.showSidebarContent = "Insights"
    } else if (this.router.url.includes("insights/maps")) {
      this.showSidebarContent = "Insights"
    } else if (this.router.url.includes("persona/overview")) {
      this.showSidebarContent = "Persona"
    } else if(this.router.url.includes("persona/manager")) {
      this.showSidebarContent = "Persona"
    } else if(this.router.url.includes("/dashboard/reporting/widget")) {
      this.showSidebarContent = "Reporting"
    }else if(this.router.url.includes("/projects/list")) {
      this.showSidebarContent = "Project list"
    }
  }

  get ProjectSortType() {
    return ProjectSortType;
  }


  async openCreateFolderDialog(): Promise<void> {
    this.filterText = "";
    const dialogRef = this.dialog.open(SpModalProjectListFolderCreateComponent, {
      minHeight: '10rem', minWidth: '30rem', maxHeight: '30rem', maxWidth: '60rem'
    });

    const sub = dialogRef.afterClosed().subscribe(folder => {
      if (folder) {
        this.projectManager.addFolder(folder, false);
      }
      sub.unsubscribe();
    });
  }
  selectFolder(folder: Folder) {
    this.filterText = "";
    this.projectReadyCount = 0;

    this.projectManager.selectFolder(folder);
    this.projectManager.reloadProjectChunks(this.filterText, this.typeFiltering);
    setTimeout(() => {
    }, 200);
  }

  changeSortType(sortType: ProjectSortType) {
    this.projectReadyCount = 0;
    this.sortType = sortType;
    this.projectManager.unloadProjectChunks();
    this.projectManager.loadProjectChunk(this.sortType, this.filterText, this.typeFiltering).then();
  }

  onTypeFilterChange(types: string[]) {
    this.isFilterProcessRunning = true;
    this.onProjectTypeFilterConfirm(types);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.projectSharedName = this.reportingMan.loadName();
    },1500);

    this.navigation.reportingEditable.subscribe(edit => {
      this.isCustomDashboardEditable = edit;
    })
    this.selectedProject = this.projectManager.selectedProjectShortcut
  }

  private onProjectTypeFilterConfirm(types: string[]) {
    if (!ArrayUtils.isSameContentIgnoringOrder(this.typeFiltering, types)) {
      this.typeFiltering = types;
      this.projectManager.projectTypeFilterListener.next(this.typeFiltering);
    }
  }
  get loadedDashboard(): Dashboard|undefined { return this.reportingMan.loadedDashboard; }

  changeSortTypeDash(sortType: ProjectSortType) {
    this.navigation.dashboardListSortListener.next(sortType);
  }

  onDashboardSearch(search: string) {
    this.navigation.dashboardListSearchListener.next(search)
  }

  /// Menu tools functionality
  sendInfoToReporting(report: string) {
    this.navigation.reportingMenuTools.next(report);
  }

  openSidebar() {
    const sidebar = document.getElementById("sp-sidebar");
    if (sidebar) sidebar.style.width = "396px";

    this.displaySidebar = true;
  }

  closeSidebar() {
    document.getElementById("sp-sidebar").style.width = "96px";

    this.displaySidebar = false;
  }

  detectClickInsideOverlay(isClicked: boolean): void {
    this.isProjectSearchClicked = isClicked;
    this.overlayContainer.getContainerElement().addEventListener('mousemove', (event) => {
      if (this.isProjectSearchClicked) {
        this.openSidebar();
        this.initSidebarContent();
      }
      this.isProjectSearchClicked = false;
      event.stopPropagation();
    });
  }

  /**
   * Event - On project search input update
   * @param search
   */
  onProjectSearch(search: string) {
    this.projectFilterChangeSubject.next(search);
    this.projectManager.projectListSearchListener.next(search);
  }
  onProjectSearchSidebar(search: string) {
    if (!search.trim()) {
      this.isPanelProjectOpen = false;
      this.isPanelFolderOpen = false;
      this.isPanelProjectInFolderOpen = false;
    } else {
      this.openPanelIfProjectFound(search);
      this.projectFilterChangeSubject.next(search);
    }
  }


  resetProjectSearch() {
    this.isPanelProjectOpen = false;
    this.isPanelFolderOpen = false;
  }

  onDashboardSearchList(search: string) {
    if (!search.trim()) {
      this.isPanelDashboardOpen = false;
      this.isPanelTemplateOpen = false;
    } else {
      this.openPanelIfDashboardFound(search);

    }
  }

  resetDashboardSearchList() {
    this.isPanelDashboardOpen = false;
    this.isPanelTemplateOpen = false;
    this.isPanelProjectInFolderOpen = false;
  }

  openPanelIfProjectFound(projectName: string) {
    this.isPanelProjectOpen = this.projectManager.allProjects.some(project => project.name.includes(projectName));
     this.folders.forEach(folder => {
       this.isPanelProjectInFolderOpen = folder.projects.some(project => project.name.includes(projectName));
       if(this.isPanelProjectInFolderOpen) {
         this.isPanelFolderOpen = true;
       }
    });
  }
  openPanelIfDashboardFound(dashboardName: string) {
      this.isPanelDashboardOpen = this.dashboardList.some(dashboard => dashboard.name.includes(dashboardName));
      this.isPanelTemplateOpen = this.templateList.some(dashboard => dashboard.name.includes(dashboardName));

  }

  restoreSelectedProject() {
    if (this.selectedProject) {
      this.projectManager.selectedProjectShortcut = this.selectedProject;
    }
  }

  folderContainsMatchingProject(folder: any): boolean {
    if (folder.projects.some(project => project.name.includes(this.filterText))) {
      this.isPanelProjectInFolderOpen = true;
      return folder.projects.some(project => project.name.includes(this.filterText));
    }

  }

  folderNameMatchesSearch(folder: any): boolean {
    if (this.filterText) {
      const searchText = this.filterText;
      const folderName = folder.name;

      return folderName.includes(searchText);
    }
    return false;
  }

  // Using ViewChild to access the child component instance
  @ViewChild(FilterDrawerComponent) filterDrawer!: FilterDrawerComponent;

  onButtonClick() {
    // Calling the openNav method from FilterDrawerComponent
    this.filterDrawer.openNav();
  }

  isOptionVisible(project: any): boolean {
    return project.name.includes(this.searchProject);
  }

  goToFolder(folder: Folder) {
    this.filterText = "";
    this.projectReadyCount = 0;

    this.projectManager.selectFolder(folder);
    this.projectManager.reloadProjectChunks(this.filterText, this.typeFiltering);
    setTimeout(() => {
    }, 200);
  }

  get showLogInToFacebookBanner() {
    return !this.forceHideFacebookBanner && (this.sessionProvider.activeSession && this.sessionProvider.activeSession.user.has_invalid_ad_accounts || !this.isFbLogged || !this.hasUserAllFbScopes);
  }

  get folders(): AnyFolder[] {
    return this.projectManager.folders;
  }

  get titleText(){
    const userName = this.sessionProvider.activeSession?.user?.first_name || '';
    return this.projectManager.openedFolder ?
      this.projectManager.openedFolder.name : 'Welcome ' + userName;

  }

  get titleCounter(){
    return this.projectManager.openedFolder ? this.projectManager.openedFolder.projects.length : this.projectManager.allProjects.length
  }

  navigateToProject(project: any) {
    this.diReportNavigator.openReportInDigitalIntelligence(project.id);
  }

  get isViewingTemplate(): boolean {
    return this.loadedDashboard?.preset === true;
  }

  get isViewingCustomDashboard(): boolean {
    return this.loadedDashboard !== undefined && !this.isViewingTemplate;
  }

  useCurrentTemplate() {
    if (this.isViewingTemplate) {
      const dialogRef = this.dialog.open(SpModalConfirmComponent, {
        width: '400px',
        data: {
          title: 'Create Custom Dashboard',
          content: 'This will create a new custom dashboard based on this template. You will be able to edit and customize it.'
        }
      });

      dialogRef.afterClosed().subscribe(async confirmed => {
        if (confirmed) {
          const dash = new Dashboard();
          dash.name = this.loadedDashboard.name;
          dash.scheme = this.loadedDashboard.scheme;
          const updatedDash = await this.apiDashboard.postOne(dash);
          this.tracker.track('reporting_dashboard_created', {name: this.loadedDashboard.name, from: 'template'});
          await this.router.navigate(['dashboard','reporting', 'list', this.projectManager.selectedProject.id, 'insight', updatedDash.id]);
          this.navigation.notifyReportingChange(updatedDash);
        }
      });
    } else {
      this.alert.notify('Error', 'This dashboard cannot be used as template', 'error');
    }
  }

  getDiUrl(path: string): string {
    return metaReportTabUrl(this.projectManager.selectedProject?.id, path);
  }

  private refreshInterestCategoriesTab(project: Project): void {
    this.showInterestCategoriesTab = this.interestCategories.supportsInterestCategories(project);
  }

  openLifestyleProfile() {
    if (this.projectManager.selectedProject) {
      const reportId = this.projectManager.selectedProject.id;
      const diUrl = `${environment.config.digitalIntelligence.domain}/meta/report/${reportId}/lifestyle-profile`;
      window.open(diUrl, '_blank');

      this.tracker.track('report_lifestyle_profile_navigated', {
        report_id: reportId,
        report_name: this.projectManager.selectedProject.name
      });
    }
  }

  openChatWithAudience() {
    if (this.projectManager.selectedProject) {
      const reportId = this.projectManager.selectedProject.id;
      const diUrl = `${environment.config.digitalIntelligence.domain}/meta/report/${reportId}/chat`;
      window.open(diUrl, '_blank');

      this.tracker.track('report_chat_with_audience_clicked', {
        report_id: reportId,
        report_name: this.projectManager.selectedProject.name
      });
    }
  }

}
